export default __webpack_public_path__ + "static/media/Sandra_Francisco_AHV_In_Moms_We_Trust.461f0395.jpg";